import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, Tabs, Tab, FooterButton } from 'Core/components';
import { showToast } from 'Core/redux/toast/slice';
import CustomPropTypes from 'Core/prop-types';
import { selectedProduct, getPrinters } from './store/selectors';
import { AppModal } from '../components/app-modals';
import { ProductionService } from '../../service/api/production-service';
import ToastService from '../../service/toast-service';
import ProductionSerialNumberTable from './production-serialnumber-table';

import ProductionSerialFilter from './production-serial-filter';
import { selectProcessStatuses } from 'Core/redux/status/selectors';
import { useTransformOptions } from 'Core/hooks';
import { fetchStatuses } from '../../core/redux/status/slice';
import ProductionPrint from './production-print';

const ProductionAddEdit = ({ showModal, modalData, onCloseModal }) => {
  const dispatch = useDispatch();
  const productionData = useSelector(selectedProduct);
  const printers = useSelector(getPrinters);
  const [formData, setFormData] = useState(productionData || null);
  const [partsData, setPartsData] = useState(productionData?.parts || []);
  const [pickTicketsData, setPickTicketsData] = useState(
    productionData?.productionPickTickets || [],
  );
  const [filesData, setFilesData] = useState(productionData?.shippingDocuments || []);
  const [loading, setLoading] = useState(true);
  const [showToast, setShowToast] = useState(false);
  const [currentToast, setCurrentToast] = useState(null);

  const isEditMode = Boolean(productionData?.partId);

  const statuses = useSelector(selectProcessStatuses);
  const statusesOptions = useTransformOptions(statuses, 'status', 'status', '', 'Select Status');

  const onChangesProductionForm = data => {
    setFormData(data);
  };

  const onChangesParts = data => {
    setPartsData(data);
  };

  const onChangesFiles = data => {
    setFilesData(data);
  };

  const onChangesPickTickets = data => {
    setPickTicketsData(data);
  };

  const handleClose = () => {
    onCloseModal();
  };

  const body = () => {
    return (
      <div className="row">
        <div className="col-12 px-lg-5">
          <ProductionPrint printers={printers} data={productionData} />
        </div>
      </div>
    );
  };

  const valid = () => {
    if (
      formData?.customerId === '' ||
      formData?.status === '' ||
      partsData?.length === 0 ||
      filesData?.length === 0
    ) {
      dispatch(
        showToast({
          message: 'Please fill all required fields',
          type: 'danger',
        }),
      );
      return false;
    }
    return true;
  };

  const footer = () => {};

  return (
    <Modal
      id="production-modal"
      show={showModal}
      size="xl"
      title={isEditMode ? 'Production Details' : 'Add Production'}
      body={body}
      footer={footer}
      handleClose={handleClose}
    />
  );
};

ProductionAddEdit.propTypes = {
  showModal: PropTypes.bool,
  modalData: PropTypes.shape(CustomPropTypes.Production),
  onCloseModal: PropTypes.func,
};

export default AppModal(ProductionAddEdit);
